import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/sama_small.svg';
const _hoisted_1 = {
  class: "navbar navbar-expand-lg bg-light border-bottom"
};
const _hoisted_2 = {
  class: "container-fluid"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "height": "29px",
    "position": "relative",
    "top": "-4px",
    "left": "15px",
    "transform": "scale(1.5)"
  }
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarScroll",
  "aria-controls": "navbarScroll",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "navbar-toggler-icon"
})], -1);
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarScroll"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<ul class=\"navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll\" style=\"--bs-scroll-height:100px;\"></ul><div class=\"dropdown border-start\"><a href=\"#\" class=\"d-flex align-items-center justify-content-center px-2 link-dark text-decoration-none dropdown-toggle\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><strong>DE</strong></a><ul class=\"dropdown-menu dropdown-menu-end text-small shadow\" style=\"\"><li><a class=\"dropdown-item active\" href=\"#\">Deutsch</a></li></ul></div>", 2);
const _hoisted_8 = {
  class: "dropdown border-start"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "d-flex align-items-center justify-content-center px-2 link-dark text-decoration-none dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-user"
})], -1);
const _hoisted_10 = {
  class: "dropdown-menu dropdown-menu-end text-small shadow",
  style: {}
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: {
      name: 'home'
    },
    class: "navbar-brand bg-white"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("ul", _hoisted_10, [_createElementVNode("li", null, [_createElementVNode("a", {
    class: "dropdown-item",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$auth.logout()),
    href: "#"
  }, "Abmelden")])])])])])]);
}